import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Zap } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import { analyticsAPI } from '../../../services/api';

const TempoRespostaInstancias = ({ filtros }) => {
  const { darkMode } = useTheme();
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const clienteId = user.cliente_id;

  useEffect(() => {
    if (!clienteId) return;
    setLoading(true);
    const params = {};
    if (filtros?.dataInicio) params.dataInicio = filtros.dataInicio;
    if (filtros?.dataFim) params.dataFim = filtros.dataFim;

    analyticsAPI.getTempoRespostaInstancias(clienteId, params)
      .then(res => setDados(res.data || []))
      .catch(() => setDados([]))
      .finally(() => setLoading(false));
  }, [clienteId, filtros?.dataInicio, filtros?.dataFim]);

  if (loading) {
    return (
      <div className={`p-4 sm:p-6 rounded-xl animate-pulse ${darkMode ? 'bg-zinc-800' : 'bg-white'}`}>
        <div className={`h-5 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded w-1/3 mb-6`}></div>
        <div className={`h-48 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded`}></div>
      </div>
    );
  }

  if (dados.length === 0) return null;

  const colors = ['#3b82f6', '#8b5cf6', '#f59e0b', '#10b981', '#ef4444'];

  return (
    <div className={`p-4 sm:p-6 rounded-xl border ${darkMode ? 'bg-zinc-800 border-gray-700' : 'bg-white border-gray-200'}`}>
      <h3 className={`text-base sm:text-lg font-semibold flex items-center gap-2 mb-4 sm:mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
        <Zap className="w-4 h-4 sm:w-5 sm:h-5" /> Desempenho por Instância
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {dados.map((inst, i) => (
          <div key={i} className={`p-3 sm:p-5 rounded-xl border-l-4 ${darkMode ? 'bg-zinc-700/30' : 'bg-gray-50'}`}
            style={{ borderLeftColor: colors[i % colors.length] }}>
            <p className={`font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              📱 {inst.nome_instancia || 'Sem nome'}
            </p>

            <div className="space-y-2">
              <div className="flex justify-between">
                <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Conversas</span>
                <span className={`text-sm font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{inst.total_conversas}</span>
              </div>
              <div className="flex justify-between">
                <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Respondidas</span>
                <span className={`text-sm font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{inst.respondidas}</span>
              </div>
              <div className="flex justify-between">
                <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Taxa resposta</span>
                <span className={`text-sm font-semibold ${Number(inst.taxa_resposta) >= 80 ? 'text-green-500' : Number(inst.taxa_resposta) >= 50 ? 'text-yellow-500' : 'text-red-500'}`}>
                  {inst.taxa_resposta || 0}%
                </span>
              </div>
              <div className="flex justify-between">
                <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Tempo médio</span>
                <span className={`text-sm font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  {inst.tempo_medio_min ? `${inst.tempo_medio_min} min` : '—'}
                </span>
              </div>
            </div>

            {/* Barra visual da taxa */}
            <div className={`mt-3 w-full rounded-full h-2 ${darkMode ? 'bg-zinc-600' : 'bg-gray-200'}`}>
              <div className="h-2 rounded-full transition-all" style={{
                width: `${inst.taxa_resposta || 0}%`,
                backgroundColor: colors[i % colors.length],
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TempoRespostaInstancias;
